import React from 'react';
import { Col, Row } from '../../lib/utils';
import { MediumText, RegularText } from '../../lib/Text';
import { MenuType } from '../Schedule/SettlementPage';
import SvgIcon from '../../components/SvgIcon';
import GroupClassToggle from '../../components/GroupClassToggle';

type Props = {
    selectedMenu: MenuType;
    onMenuClick: (menuType: MenuType) => void;
    onCommissionClick: () => void;
    onVatPolicyClick: () => void;
    /** trial 관리자만 라포페이 정산 탭 노출 */
    isRappoPaySettlementMenuVisible?: boolean;
    /** 서버에 세션 현황 기능이 있을 때만 노출(구서버·권한 없음이면 기존 탭 줄 그대로) */
    isSessionReportMenuVisible?: boolean;
};

const menuList = [
    {
        title: '매출 달력',
        menuType: 'calendar',
    },
    {
        title: '수업료 정산',
        menuType: 'classSales',
    },
    {
        title: '매출 목록',
        menuType: 'salesList',
    },
    {
        title: '라포페이',
        menuType: 'rappoPaySettlement',
    },
    {
        title: '미수금 목록',
        menuType: 'unpaidList',
    },
    {
        title: '급여 계산',
        menuType: 'salaryCalculation',
    },
    {
        title: '세션 현황',
        menuType: 'sessionReport',
    },
];

const SettlementHeader = ({
    selectedMenu,
    onMenuClick,
    onCommissionClick,
    onVatPolicyClick,
    isRappoPaySettlementMenuVisible = false,
    isSessionReportMenuVisible = false,
}: Props) => {
    const visibleMenuList = menuList.filter(
        (menu) =>
            (menu.menuType !== 'rappoPaySettlement' || isRappoPaySettlementMenuVisible) &&
            (menu.menuType !== 'sessionReport' || isSessionReportMenuVisible),
    );

    // 세션 현황 탭이 실제로 보이고 탭이 6개 이상일 때만 밀집 스타일(간격 36px·줄바꿈 금지·바깥 gap·마지막 탭 여백 제거).
    // 그 밖(기존 5개, 체험 계정의 라포페이 포함 6개)은 바꾸기 전 클래스 그대로.
    const isCrowded = isSessionReportMenuVisible && visibleMenuList.length >= 6;

    return (
        <Row
            className={`mt-[40px] mb-[33px] self-start items-center justify-between flex w-full${
                isCrowded ? ' gap-[24px]' : ''
            }`}
        >
            <Row className="flex items-center">
                {visibleMenuList.map((menu, index) => (
                    <Col
                        key={menu.menuType}
                        className={!isCrowded ? 'mr-[42px]' : index === visibleMenuList.length - 1 ? '' : 'mr-[36px]'}
                        onClick={() => onMenuClick(menu.menuType as MenuType)}
                    >
                        <MediumText
                            fontSize={25}
                            lineHeight={32}
                            color={selectedMenu === menu.menuType ? '#3D4244' : '#6B7280'}
                            className={isCrowded ? 'mb-[8px] cursor-pointer whitespace-nowrap' : 'mb-[8px] cursor-pointer'}
                        >
                            {menu.title}
                        </MediumText>
                        {selectedMenu === menu.menuType && <div className={`w-full h-[5px] bg-[#3D4244]`} />}
                    </Col>
                ))}
            </Row>

            <Row className="flex items-center gap-[17px]">
                <GroupClassToggle />
                <Row
                    className="bg-[#2D3132] rounded-[10px] justify-center items-center flex-row flex px-[14px] h-[45px] cursor-pointer"
                    onClick={onVatPolicyClick}
                >
                    <SvgIcon name={'SvgSetting'} size={17} fill={'white'} className="mr-[9px]" />
                    <RegularText fontSize={16} lineHeight={23} letterSpacing={-0.3} color="white">
                        부가세 설정
                    </RegularText>
                </Row>
                <Row
                    className="bg-[#2D3132] rounded-[10px] justify-center items-center flex-row flex px-[14px] h-[45px] cursor-pointer"
                    onClick={onCommissionClick}
                >
                    <SvgIcon name={'SvgSetting'} size={17} fill={'white'} className="mr-[9px]" />
                    <RegularText fontSize={16} lineHeight={23} letterSpacing={-0.3} color="white">
                        수업 정산 비율 설정
                    </RegularText>
                </Row>
            </Row>
        </Row>
    );
};

export default SettlementHeader;
